<div
  class="modal fade confirm-dialog"
  [class.confirm-dialog-stacked]="stackAboveModal"
  [id]="modalId"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered confirm-dialog-container">
    <div class="modal-content confirm-dialog-content">
      <div class="confirm-dialog-icon" [ngClass]="'confirm-dialog-icon-' + icon">
        <img
          *ngIf="icon === 'trash'"
          src="assets/media/icons/svg/alert-trash.svg"
          class="confirm-dialog-trash-icon"
          alt=""
          aria-hidden="true"
        />
        <span
          *ngIf="icon === 'warning'"
          class="confirm-dialog-warning-icon"
          aria-hidden="true"
        >
          !
        </span>
        <span
          *ngIf="icon === 'success'"
          class="confirm-dialog-success-icon"
          aria-hidden="true"
        ></span>
        <span
          *ngIf="icon === 'error'"
          class="confirm-dialog-error-icon"
          aria-hidden="true"
        ></span>
      </div>

      <h5 class="confirm-dialog-title">{{ title }}</h5>
      <p class="confirm-dialog-message">{{ message }}</p>

      <div class="confirm-dialog-actions">
        <button
          *ngIf="showCancelButton"
          type="button"
          class="btn confirm-dialog-cancel-button"
          [disabled]="isProcessing"
          (click)="onCancel()"
        >
          {{ cancelText }}
        </button>

        <button
          type="button"
          class="btn confirm-dialog-confirm-button"
          [disabled]="isProcessing"
          (click)="onConfirm()"
        >
          {{ confirmText }}
        </button>
      </div>
    </div>
  </div>
</div>
